function loader(fn, ...args) {
  return import(/* webpackChunkName: "core_flow_async" */ './~flow').then(res => {
    return res.default[fn](...args);
  });
}
export default {
  //发送
  send(args) {
    loader('send', args);
  },
  // 退回
  sendBack(args) {
    loader('sendBack', args);
  },
  // 销毁
  destroy(args) {
    loader('destroy', args);
  },
  // 回收 强制回收 强制办结
  recovery(args) {
    loader('recovery', args);
  },
  // 环节回收 和 强制环节回收
  recoveryLink(args) {
    loader('recoveryLink', args);
  },
  // 申请回收
  applyRecovery(args) {
    loader('applyRecovery', args);
  },
  // 流转情况
  situation(args) {
    loader('situation', args);
  },
  // 更换处理人
  changeHandler(args) {
    loader('changeHandler', args);
  },
  // 填写处理意见
  addComment(args) {
    loader('addComment', args);
  },
  // 自动签收
  autoReceive(_self, param) {
    loader('autoReceive', _self, param);
  },
  // 获取当前节点信息
  getLinkCurInfo(autoReceive, _self) {
    loader('getLinkCurInfo', autoReceive, _self);
  },
  // 开始发送
  startSend(args) {
    loader('startSend', args);
  }
};